import { BaseControlledModal } from "../../../../common/components/base_controlled_modal";
import { GetReportJobStatusResponse } from "../../../reports/data/daos/read/get_report_job_status";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import PrimaryButton from "../../../../common/components/primary_button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DownloadIcon from "@mui/icons-material/Download";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

/**
 * ReportJobWaiterModal
 */

type Props = {
  open: boolean;
  result: GetReportJobStatusResponse | null;
  onClose: () => void;
};

export const ReportJobWaiterModal = ({
  open,
  result,
  onClose,
}: Props) => {
  const download = result?.download && new Date(result.download.expiraEm).getTime() > Date.now()
    ? result.download
    : null;

  return (
    <BaseControlledModal
      open={open}
      saving={false}
      loading={false}
      showConfirmButton={false}
      width="32rem"
      cancelButtonLabel="Fechar"
      title={result ? "Relatório concluído" : "Gerando relatório"}
      onClose={onClose}>
      <Stack spacing={3} alignItems="center" sx={{ py: 2 }} role="status" aria-live="polite">
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: 72, height: 72, borderRadius: "50%", bgcolor: "action.hover" }}>
          {result ? (
            <CheckCircleOutlineIcon color="success" sx={{ fontSize: 40 }} />
          ) : (
            <CircularProgress size={36} aria-label="Gerando relatório" />
          )}
        </Box>

        <Stack spacing={1} textAlign="center">
          <Typography variant="h6">
            {result ? "Tudo pronto!" : "Preparando seu relatório"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {result
              ? download ? "Seu arquivo está disponível para download." : "A tarefa foi concluída. Não há arquivo disponível para download."
              : "Isso pode levar alguns minutos. O download ficará disponível aqui assim que terminarmos."}
          </Typography>
        </Stack>

        {download && (
          <Stack spacing={2} sx={{ width: "100%" }}>
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ p: 2, border: 1, borderColor: "divider", borderRadius: 2, bgcolor: "action.hover" }}>
              <InsertDriveFileOutlinedIcon color="action" />
              <Typography variant="body2" sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
                {download.nomeArquivo}
              </Typography>
            </Stack>
            <PrimaryButton
              buttonColor="primary-green"
              startIcon={<DownloadIcon />}
              href={download.url}
              onClick={event => {
                event.preventDefault();
                window.open(download.url, "_blank", "noopener,noreferrer");
              }}>
              Baixar relatório
            </PrimaryButton>
          </Stack>
        )}
      </Stack>
    </BaseControlledModal>
  );
}
